(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-pass"]) return;
  try {
    
  document.querySelectorAll('[data-oree-pdp]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-oree-variants]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var inputs = root.querySelectorAll('[data-oree-option]');
    if (!inputs.length) return;

    function onChange() {
      var opts = [];
      inputs.forEach(function (el) {
        var i = parseInt(el.dataset.index, 10);
        if (el.tagName === 'SELECT') { opts[i] = el.value; }
        else if (el.checked) { opts[i] = el.value; }
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var idInput = root.querySelector('[data-oree-variant-id]');
      var prices = root.querySelectorAll('[data-oree-price]');
      var comparePrices = root.querySelectorAll('[data-oree-compare-price]');
      var dot = root.querySelector('[data-oree-status-dot]');
      var label = root.querySelector('[data-oree-status-label]');
      var buys = root.querySelectorAll('[data-oree-buy]');
      var img = root.querySelector('.oree-pdp__main img');

      if (!variant) {
        buys.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      root.querySelectorAll('[data-oree-optval]').forEach(function (el) {
        var i = parseInt(el.dataset.oreeOptval, 10);
        if (opts[i]) el.textContent = '· ' + opts[i];
      });
      prices.forEach(function (p) { p.textContent = variant.price; });
      comparePrices.forEach(function (p) {
        if (variant.compareAtPrice) { p.textContent = variant.compareAtPrice; p.hidden = false; }
        else { p.hidden = true; p.textContent = ''; }
      });
      if (dot) dot.style.background = variant.available ? 'var(--sage-500)' : 'var(--ember-500)';
      if (label) label.textContent = variant.available ? 'Available' : 'Sold';
      buys.forEach(function (b) {
        b.disabled = !variant.available;
        b.textContent = variant.available ? b.dataset.label : b.dataset.labelSold;
      });
      if (img && variant.media) { img.removeAttribute('srcset'); img.src = variant.media; }
    }

    inputs.forEach(function (el) { el.addEventListener('change', onChange); });

    /* Gift card recipient form — toggle visibility + required-ness */
    var recipientForm = root.querySelector('[data-oree-recipient-form]');
    if (recipientForm) {
      var checkbox = recipientForm.querySelector('[data-oree-recipient-checkbox]');
      var fields = recipientForm.querySelector('[data-oree-recipient-fields]');
      var emailInput = recipientForm.querySelector('[data-oree-recipient-email]');
      var offsetInput = recipientForm.querySelector('[data-oree-recipient-offset]');
      if (offsetInput) offsetInput.value = new Date().getTimezoneOffset();
      function syncRecipient() {
        var on = checkbox.checked;
        fields.hidden = !on;
        if (emailInput) emailInput.required = on;
      }
      if (checkbox) {
        checkbox.addEventListener('change', syncRecipient);
        syncRecipient();
      }
    }

    /* Sticky reserve bar — reveal once the main buy button scrolls above the viewport */
    var stickybar = root.querySelector('[data-oree-stickybar]');
    var mainBuy = root.querySelector('[data-oree-buy-main]');
    if (stickybar && mainBuy && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var pastIt = !e.isIntersecting && e.boundingClientRect.top < 0;
          if (pastIt) { stickybar.setAttribute('data-visible', ''); }
          else { stickybar.removeAttribute('data-visible'); }
        });
      }, { threshold: 0 });
      io.observe(mainBuy);
    }
  });

  /* Gallery — thumbnails, arrows, and fullscreen image */
document.querySelectorAll('[data-oree-pdp]').forEach(function (root) {

  var mainImg = root.querySelector('.oree-pdp__main img');
  var thumbs = Array.from(root.querySelectorAll('[data-oree-thumb]'));
  var next = root.querySelector('[data-gallery-next]');
  var prev = root.querySelector('[data-gallery-prev]');

  if (!mainImg) return;

  var current = 0;

  function showImage(index) {
    if (!thumbs.length) return;

    current = index;

    var full = thumbs[current].getAttribute('data-full');

    if (full) {
      mainImg.removeAttribute('srcset');
      mainImg.src = full;
    }

    thumbs.forEach(function (t) {
      t.removeAttribute('data-active');
    });

    thumbs[current].setAttribute('data-active', '');
  }


  // Thumbnail clicks
  thumbs.forEach(function (btn, index) {
    btn.addEventListener('click', function () {
      showImage(index);
    });
  });


  // Next arrow
  if (next) {
    next.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      showImage((current + 1) % thumbs.length);
    });
  }


  // Previous arrow
  if (prev) {
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      showImage((current - 1 + thumbs.length) % thumbs.length);
    });
  }


  // Fullscreen lightbox
  var lightbox = root.querySelector('[data-oree-lightbox]');
  var lightboxImg = root.querySelector('[data-lightbox-image]');
  var close = root.querySelector('[data-lightbox-close]');
  var lightboxPrev = root.querySelector('[data-lightbox-prev]');
var lightboxNext = root.querySelector('[data-lightbox-next]');


  if (lightbox && lightboxImg) {

    mainImg.addEventListener('click', function () {

      lightboxImg.src = mainImg.src;
      lightbox.setAttribute('data-open', '');
      lightbox.setAttribute('aria-hidden', 'false');

    });
    if (lightboxPrev) {
  lightboxPrev.addEventListener('click', function () {
    showImage((current - 1 + thumbs.length) % thumbs.length);
    lightboxImg.src = mainImg.src;
  });
}

if (lightboxNext) {
  lightboxNext.addEventListener('click', function () {
    showImage((current + 1) % thumbs.length);
    lightboxImg.src = mainImg.src;
  });
}


    if (close) {
      close.addEventListener('click', function () {
        lightbox.removeAttribute('data-open');
        lightbox.setAttribute('aria-hidden', 'true');
      });
    }


    lightbox.addEventListener('click', function (e) {

      if (e.target === lightbox) {
        lightbox.removeAttribute('data-open');
        lightbox.setAttribute('aria-hidden', 'true');
      }

    });

  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-oree-pdp]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-oree-variants]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var inputs = root.querySelectorAll('[data-oree-option]');
    if (!inputs.length) return;

    function onChange() {
      var opts = [];
      inputs.forEach(function (el) {
        var i = parseInt(el.dataset.index, 10);
        if (el.tagName === 'SELECT') { opts[i] = el.value; }
        else if (el.checked) { opts[i] = el.value; }
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var idInput = root.querySelector('[data-oree-variant-id]');
      var prices = root.querySelectorAll('[data-oree-price]');
      var comparePrices = root.querySelectorAll('[data-oree-compare-price]');
      var dot = root.querySelector('[data-oree-status-dot]');
      var label = root.querySelector('[data-oree-status-label]');
      var buys = root.querySelectorAll('[data-oree-buy]');
      var img = root.querySelector('.oree-pdp__main img');

      if (!variant) {
        buys.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      root.querySelectorAll('[data-oree-optval]').forEach(function (el) {
        var i = parseInt(el.dataset.oreeOptval, 10);
        if (opts[i]) el.textContent = '· ' + opts[i];
      });
      prices.forEach(function (p) { p.textContent = variant.price; });
      comparePrices.forEach(function (p) {
        if (variant.compareAtPrice) { p.textContent = variant.compareAtPrice; p.hidden = false; }
        else { p.hidden = true; p.textContent = ''; }
      });
      if (dot) dot.style.background = variant.available ? 'var(--sage-500)' : 'var(--ember-500)';
      if (label) label.textContent = variant.available ? 'Available' : 'Sold';
      buys.forEach(function (b) {
        b.disabled = !variant.available;
        b.textContent = variant.available ? b.dataset.label : b.dataset.labelSold;
      });
      if (img && variant.media) { img.removeAttribute('srcset'); img.src = variant.media; }
    }

    inputs.forEach(function (el) { el.addEventListener('change', onChange); });

    /* Gift card recipient form — toggle visibility + required-ness */
    var recipientForm = root.querySelector('[data-oree-recipient-form]');
    if (recipientForm) {
      var checkbox = recipientForm.querySelector('[data-oree-recipient-checkbox]');
      var fields = recipientForm.querySelector('[data-oree-recipient-fields]');
      var emailInput = recipientForm.querySelector('[data-oree-recipient-email]');
      var offsetInput = recipientForm.querySelector('[data-oree-recipient-offset]');
      if (offsetInput) offsetInput.value = new Date().getTimezoneOffset();
      function syncRecipient() {
        var on = checkbox.checked;
        fields.hidden = !on;
        if (emailInput) emailInput.required = on;
      }
      if (checkbox) {
        checkbox.addEventListener('change', syncRecipient);
        syncRecipient();
      }
    }

    /* Sticky reserve bar — reveal once the main buy button scrolls above the viewport */
    var stickybar = root.querySelector('[data-oree-stickybar]');
    var mainBuy = root.querySelector('[data-oree-buy-main]');
    if (stickybar && mainBuy && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var pastIt = !e.isIntersecting && e.boundingClientRect.top < 0;
          if (pastIt) { stickybar.setAttribute('data-visible', ''); }
          else { stickybar.removeAttribute('data-visible'); }
        });
      }, { threshold: 0 });
      io.observe(mainBuy);
    }
  });

  /* Gallery — thumbnails, arrows, and fullscreen image */
document.querySelectorAll('[data-oree-pdp]').forEach(function (root) {

  var mainImg = root.querySelector('.oree-pdp__main img');
  var thumbs = Array.from(root.querySelectorAll('[data-oree-thumb]'));
  var next = root.querySelector('[data-gallery-next]');
  var prev = root.querySelector('[data-gallery-prev]');

  if (!mainImg) return;

  var current = 0;

  function showImage(index) {
    if (!thumbs.length) return;

    current = index;

    var full = thumbs[current].getAttribute('data-full');

    if (full) {
      mainImg.removeAttribute('srcset');
      mainImg.src = full;
    }

    thumbs.forEach(function (t) {
      t.removeAttribute('data-active');
    });

    thumbs[current].setAttribute('data-active', '');
  }


  // Thumbnail clicks
  thumbs.forEach(function (btn, index) {
    btn.addEventListener('click', function () {
      showImage(index);
    });
  });


  // Next arrow
  if (next) {
    next.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      showImage((current + 1) % thumbs.length);
    });
  }


  // Previous arrow
  if (prev) {
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      showImage((current - 1 + thumbs.length) % thumbs.length);
    });
  }


  // Fullscreen lightbox
  var lightbox = root.querySelector('[data-oree-lightbox]');
  var lightboxImg = root.querySelector('[data-lightbox-image]');
  var close = root.querySelector('[data-lightbox-close]');
  var lightboxPrev = root.querySelector('[data-lightbox-prev]');
var lightboxNext = root.querySelector('[data-lightbox-next]');


  if (lightbox && lightboxImg) {

    mainImg.addEventListener('click', function () {

      lightboxImg.src = mainImg.src;
      lightbox.setAttribute('data-open', '');
      lightbox.setAttribute('aria-hidden', 'false');

    });
    if (lightboxPrev) {
  lightboxPrev.addEventListener('click', function () {
    showImage((current - 1 + thumbs.length) % thumbs.length);
    lightboxImg.src = mainImg.src;
  });
}

if (lightboxNext) {
  lightboxNext.addEventListener('click', function () {
    showImage((current + 1) % thumbs.length);
    lightboxImg.src = mainImg.src;
  });
}


    if (close) {
      close.addEventListener('click', function () {
        lightbox.removeAttribute('data-open');
        lightbox.setAttribute('aria-hidden', 'true');
      });
    }


    lightbox.addEventListener('click', function (e) {

      if (e.target === lightbox) {
        lightbox.removeAttribute('data-open');
        lightbox.setAttribute('aria-hidden', 'true');
      }

    });

  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oree-workshops"]) return;
  try {
    
  document.querySelectorAll('[data-oree-pdp]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-oree-variants]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var inputs = root.querySelectorAll('[data-oree-option]');
    if (!inputs.length) return;

    function onChange() {
      var opts = [];
      inputs.forEach(function (el) {
        var i = parseInt(el.dataset.index, 10);
        if (el.tagName === 'SELECT') { opts[i] = el.value; }
        else if (el.checked) { opts[i] = el.value; }
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var idInput = root.querySelector('[data-oree-variant-id]');
      var prices = root.querySelectorAll('[data-oree-price]');
      var comparePrices = root.querySelectorAll('[data-oree-compare-price]');
      var dot = root.querySelector('[data-oree-status-dot]');
      var label = root.querySelector('[data-oree-status-label]');
      var buys = root.querySelectorAll('[data-oree-buy]');
      var img = root.querySelector('.oree-pdp__main img');

      if (!variant) {
        buys.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      root.querySelectorAll('[data-oree-optval]').forEach(function (el) {
        var i = parseInt(el.dataset.oreeOptval, 10);
        if (opts[i]) el.textContent = '· ' + opts[i];
      });
      prices.forEach(function (p) { p.textContent = variant.price; });
      comparePrices.forEach(function (p) {
        if (variant.compareAtPrice) { p.textContent = variant.compareAtPrice; p.hidden = false; }
        else { p.hidden = true; p.textContent = ''; }
      });
      if (dot) dot.style.background = variant.available ? 'var(--sage-500)' : 'var(--ember-500)';
      if (label) label.textContent = variant.available ? 'Available' : 'Sold';
      buys.forEach(function (b) {
        b.disabled = !variant.available;
        b.textContent = variant.available ? b.dataset.label : b.dataset.labelSold;
      });
      if (img && variant.media) { img.removeAttribute('srcset'); img.src = variant.media; }
    }

    inputs.forEach(function (el) { el.addEventListener('change', onChange); });

    /* Gift card recipient form — toggle visibility + required-ness */
    var recipientForm = root.querySelector('[data-oree-recipient-form]');
    if (recipientForm) {
      var checkbox = recipientForm.querySelector('[data-oree-recipient-checkbox]');
      var fields = recipientForm.querySelector('[data-oree-recipient-fields]');
      var emailInput = recipientForm.querySelector('[data-oree-recipient-email]');
      var offsetInput = recipientForm.querySelector('[data-oree-recipient-offset]');
      if (offsetInput) offsetInput.value = new Date().getTimezoneOffset();
      function syncRecipient() {
        var on = checkbox.checked;
        fields.hidden = !on;
        if (emailInput) emailInput.required = on;
      }
      if (checkbox) {
        checkbox.addEventListener('change', syncRecipient);
        syncRecipient();
      }
    }

    /* Sticky reserve bar — reveal once the main buy button scrolls above the viewport */
    var stickybar = root.querySelector('[data-oree-stickybar]');
    var mainBuy = root.querySelector('[data-oree-buy-main]');
    if (stickybar && mainBuy && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var pastIt = !e.isIntersecting && e.boundingClientRect.top < 0;
          if (pastIt) { stickybar.setAttribute('data-visible', ''); }
          else { stickybar.removeAttribute('data-visible'); }
        });
      }, { threshold: 0 });
      io.observe(mainBuy);
    }
  });

  /* Gallery — thumbnails, arrows, and fullscreen image */
document.querySelectorAll('[data-oree-pdp]').forEach(function (root) {

  var mainImg = root.querySelector('.oree-pdp__main img');
  var thumbs = Array.from(root.querySelectorAll('[data-oree-thumb]'));
  var next = root.querySelector('[data-gallery-next]');
  var prev = root.querySelector('[data-gallery-prev]');

  if (!mainImg) return;

  var current = 0;

  function showImage(index) {
    if (!thumbs.length) return;

    current = index;

    var full = thumbs[current].getAttribute('data-full');

    if (full) {
      mainImg.removeAttribute('srcset');
      mainImg.src = full;
    }

    thumbs.forEach(function (t) {
      t.removeAttribute('data-active');
    });

    thumbs[current].setAttribute('data-active', '');
  }


  // Thumbnail clicks
  thumbs.forEach(function (btn, index) {
    btn.addEventListener('click', function () {
      showImage(index);
    });
  });


  // Next arrow
  if (next) {
    next.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      showImage((current + 1) % thumbs.length);
    });
  }


  // Previous arrow
  if (prev) {
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      showImage((current - 1 + thumbs.length) % thumbs.length);
    });
  }


  // Fullscreen lightbox
  var lightbox = root.querySelector('[data-oree-lightbox]');
  var lightboxImg = root.querySelector('[data-lightbox-image]');
  var close = root.querySelector('[data-lightbox-close]');
  var lightboxPrev = root.querySelector('[data-lightbox-prev]');
var lightboxNext = root.querySelector('[data-lightbox-next]');


  if (lightbox && lightboxImg) {

    mainImg.addEventListener('click', function () {

      lightboxImg.src = mainImg.src;
      lightbox.setAttribute('data-open', '');
      lightbox.setAttribute('aria-hidden', 'false');

    });
    if (lightboxPrev) {
  lightboxPrev.addEventListener('click', function () {
    showImage((current - 1 + thumbs.length) % thumbs.length);
    lightboxImg.src = mainImg.src;
  });
}

if (lightboxNext) {
  lightboxNext.addEventListener('click', function () {
    showImage((current + 1) % thumbs.length);
    lightboxImg.src = mainImg.src;
  });
}


    if (close) {
      close.addEventListener('click', function () {
        lightbox.removeAttribute('data-open');
        lightbox.setAttribute('aria-hidden', 'true');
      });
    }


    lightbox.addEventListener('click', function (e) {

      if (e.target === lightbox) {
        lightbox.removeAttribute('data-open');
        lightbox.setAttribute('aria-hidden', 'true');
      }

    });

  }

});

  } catch(e) { console.error(e); }
})();
})();
